import { getSpamChats } from './getSpamChats';
import { getLastTimeStamp } from '../../reducers/chatList/helpers';
import { TThunkAction } from '../../types/redux/thunk';

export const getSpamListNextPage = (): TThunkAction<void> => (dispatch, getState) => {
  const state = getState();
  const { chatList } = state;

  const timestampSpam = chatList.chats.length ? getLastTimeStamp(chatList.chats) : state.chatList.timestampSpam;

  dispatch(getSpamChats({ timestampSpam }));
};
